

<template>
	<div>
		<v-row class="">
			<v-col cols="6" md="2">
				<p class="sub-text-light">{{$lang.CURRENT_PLAN}}</p>
				<p class="sub-title-text-dark">{{current_plan_name}}</p>
			</v-col>	
			<v-col cols="6" md="2">
				<p class="sub-text-light">{{$lang.DAYS_REMAINING}}</p>
				<p class="sub-title-text-dark">{{days_remaining}}</p>
			</v-col>
			<v-col cols="6" md="2">
				<p class="sub-text-light">{{$lang.SHIPMENT_REMAINING}}</p>
				<p class="sub-title-text-dark">{{shipment_remaining}}</p>
			</v-col>
			<v-col cols="6" md="2">
				<p class="sub-text-light">{{$lang.TYPE}}</p>
				<p class="sub-title-text-dark">{{type}}</p>
			</v-col>
		</v-row >

		<!-- subscription plan list  -->
		<subscription-card :subscription_plans="subscription_plans" :neft_imps_payment_instructions="neft_imps_payment_instructions" :cheque_payment_instructions="cheque_payment_instructions" :current_plan_id="current_plan_id" />



		<!-- subscription History  -->

		<subscription-history/>

	</div>
</template>
<script type="text/javascript">
// import { Carousel, Slide } from 'vue-carousel';

export default {
	components: {
		SubscriptionHistory :()=>import("./SubscriptionHistory.vue"),
		SubscriptionCard :()=>import("./child/SubscriptionCard.vue")
	},
	data () {
		return {
			speed:1000,
			paginationenabled:true,
			autoplay:false,
			item_per_page:3,
			current_plan_name:"",
			current_plan_id:"",
			days_remaining:"",
			type:"",
			shipment_remaining:"",
			subscription_plans:[],
			neft_imps_payment_instructions:"",
			cheque_payment_instructions:"",

		}
	},
	created(){
		this.getSubscriptionPlanList();
	},
	methods:{
		/* fetch wholesaler details */ 
		getSubscriptionPlanList(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={};

			const successHandler = (response) => {
				if (response.data.success){
					self.subscription_plans=response.data.subscription_list
					self.days_remaining=response.data.days_remaining
					self.shipment_remaining=response.data.shipment_remaining
					self.current_plan_name=response.data.name
					self.current_plan_id=response.data.id
					self.type=response.data.type
					self.neft_imps_payment_instructions=response.data.neft_imps_payment_instructions
					self.cheque_payment_instructions=response.data.cheque_payment_instructions
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
				
			};
			self.request_GET( self,self.$urls.SUBSCRIPTON_LIST,params,successHandler,null,null,finallyHandler)

		},
	}
}
</script>